module.exports = __webpack_public_path__ + "fca8fd30cb2c4982f4d3cd7220b15df3.svg";